/* eslint-disable import/prefer-default-export */
/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { RootState } from '../store';
import Config from '../shared/entities/config';

export enum FEATURE_FLAGS {
  isFullTailViewEnabled = 'isFullTailViewEnabled',
  isSatellitesInFOVEnabled = 'isSatellitesInFOVEnabled',
  isNextSatellitePanelEnabled = 'isNextSatellitePanelEnabled',
  isMptEnabled = 'isMptEnabled',
  isTerminalInBeamEnabled = 'isTerminalInBeamEnabled',
  isHCXEnabled = 'isHCXEnabled',
  isVs3Enabled = 'isVs3Enabled',
  isGxEnabled = 'isGxEnabled',
  areKaHnaZonesEnabled = 'areKaHnaZonesEnabled',
  areHcxHnaZonesEnabled = 'areHcxHnaZonesEnabled',
  areGxHnaZonesEnabled = 'areGxHnaZonesEnabled',
  isHnaOverrideButtonEnabled = 'isHnaOverrideButtonEnabled',
  hcxHnaRequestOverrideColumnVisible = 'hcxHnaRequestOverrideColumnVisible',
  isTthoEnabled = 'isTthoEnabled',
  seasonalFunEnabled = 'seasonalFunEnabled',
}

export const isFeatureEnabled = (appConfig: Config, featureFlag: keyof typeof FEATURE_FLAGS) => {
  return !!(appConfig || {})[featureFlag];
};

export const requireFeatureFlag = <Props extends object>(
  FeatureComponent: React.ComponentType<Props>,
  featureFlag: keyof typeof FEATURE_FLAGS,
  redirectPath: string | null = null,
  passThroProps: any = {},
) => {
  class FeatureFlagHOC extends React.Component<typeof RouteComponentProps & Props & StateProps> {
    private shouldRedirect = () => {
      const { history, isFeatureFlagEnabled, isInitialConfigRequestFinished } = this.props;

      if (!isFeatureFlagEnabled && redirectPath && isInitialConfigRequestFinished) {
        history.replace(redirectPath);
      }
    };

    public componentDidMount() {
      this.shouldRedirect();
    }

    public componentDidUpdate() {
      this.shouldRedirect();
    }

    public render() {
      const { history, isFeatureFlagEnabled, ...rest } = this.props;

      return isFeatureFlagEnabled ? <FeatureComponent {...rest} {...passThroProps} /> : null;
    }
  }

  const mapStateToProps = (root: RootState) => ({
    isFeatureFlagEnabled: root.config.appConfig[featureFlag],
    isInitialConfigRequestFinished: root.config.isInitialConfigRequestFinished,
  });
  type StateProps = ReturnType<typeof mapStateToProps>;

  return withRouter(connect(mapStateToProps)(FeatureFlagHOC));
};
